import preval from 'babel-plugin-preval/macro';
import { withPrefix } from 'gatsby';
import { UserManagerSettings } from 'oidc-client';
import { WebStorageStateStore } from 'oidc-client';

interface UsageLogIdLookup {
  memberSite: number;
  myecri: number;
  profile: number;
}

export enum LoginSource {
  UserNameAndPassword = '1',
  Ip = '2',
  SecureLink = '3',
  FederatedSso = '4',
}

export const usageLogIds: UsageLogIdLookup = {
  ...preval`
      require('dotenv').config();
      require('dotenv').config({
        path: ".env." + process.env.NODE_ENV,
      });
      module.exports = {
        memberSite: Number(
          process.env.GATSBY_MEMBER_SITE_USAGE_LOG_ID
        ),
        myecri: Number(
         process.env.GATSBY_MYECRI_SITE_USAGE_LOG_ID
        ),
        profile: Number(
           process.env.GATSBY_PROFILE_SITE_USAGE_LOG_ID
        )
      }
  `,
};

export const determineMemberSiteUrl = () => {
  if (process.env.NODE_ENV === 'development' || typeof window === 'undefined') {
    return '/';
  }
  const { hostname } = (window || {}).location || {};
  if (hostname && hostname !== '') {
    return `https://${hostname}/`;
  }
  return 'https://www.ecri.org/';
};

const determineLoginAuthority = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'https://sts.dev.ecri.org/';
  }
  const { hostname = 'localhost' } = (window || {}).location || {};

  if (hostname === 'www.ecri.org' || hostname === 'my.ecri.org') {
    return 'https://sts.ecri.org/';
  }

  if (
    hostname === 'www2016.stage.ecri.org' ||
    hostname === 'stage-www.ecri.org' ||
    hostname === 'my-stage.ecri.org'
  ) {
    return 'https://sts.stage.ecri.org/';
  }
  if (
    hostname === 'beta-www.ecri.org' ||
    hostname === 'my-beta.ecri.org' ||
    hostname === 'myecri-beta.ecri.org'
  ) {
    return 'https://sts-beta.ecri.org/';
  }

  return 'https://sts.dev.ecri.org/';
};

export const determineLMSURL = () => {
  if (process.env.NODE_ENV !== 'production')
    return 'https://ecri.hosted.test.cloud.ethosce.com/user/login';
  else
    return 'https://learning.ecri.org/user/login';
};

export const isUrlAbsolute = (url: string) => {
  let pattern = /^https:\/\//i;

  if(pattern.test(url)) {
    return true;
  } else return false;
};

export const determineShopifyURL = (returnUrl: string, absoluteUrl: boolean, email: string) => {

  const devReturnUrl =  absoluteUrl ? decodeURIComponent(returnUrl) : `https://ecrishop-dev.myshopify.com${returnUrl}`;
  const prodReturnUrl = absoluteUrl ? decodeURIComponent(returnUrl) : `https://home.ecri.org${returnUrl}`;

  if (process.env.NODE_ENV !== 'production') {
    return `https://sts.dev.ecri.org/account/login?ReturnUrl=${devReturnUrl}&UserEmail=${email}`;
  }

  const { hostname } = (typeof window !=='undefined' && window || {}).location || {};

  if (hostname === 'www.ecri.org' || hostname === 'my.ecri.org') {
    return `https://sts.ecri.org/account/login?ReturnUrl=${prodReturnUrl}&UserEmail=${email}`;
  }

  if (
    hostname === 'beta-www.ecri.org' ||
    hostname === 'my-beta.ecri.org' ||
    hostname === 'myecri-beta.ecri.org'
  ) {
    return `https://sts-beta.ecri.org/account/login?ReturnUrl=${prodReturnUrl}&UserEmail=${email}`;
  }

  return `https://sts.dev.ecri.org/account/login?ReturnUrl=${devReturnUrl}&UserEmail=${email}`
};

export const createUserManagerConfig = (
  window: Window
): UserManagerSettings => {
  return {
    authority: determineLoginAuthority(),
    client_id: 'myecri.ui',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }${withPrefix('/auth-callback')}`,
    post_logout_redirect_uri: `${window.location.protocol}//${
      window.location.hostname
    }${window.location.port ? `:${window.location.port}` : ''}/`,
    silent_redirect_uri: `${window.location.protocol}//${
      window.location.hostname
    }${window.location.port ? `:${window.location.port}` : ''}${withPrefix(
      '/silent_renew.html'
    )}`,
    response_type: 'code',
    scope: 'openid ecri.profile ecri.profile.extended myecri.api.rw',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: sessionStorage }),
  };
};
